import { __read } from "tslib";
import { ResourceErrorMonitor } from '../../monitors/resource-error';
import { applyMonitor } from '../../utils';
import { getPluginConfig } from './utils';
export var RESOURCE_ERROR_MONITOR_PLUGIN_NAME = 'resourceError';
var defaultConfig = {
    includeUrls: [],
    ignoreUrls: [],
    dedupe: true,
};
export function ResourceErrorMonitorPlugin(client) {
    client.on('init', function () {
        var config = getPluginConfig(client, RESOURCE_ERROR_MONITOR_PLUGIN_NAME, defaultConfig);
        if (!config) {
            return;
        }
        var _a = __read(applyMonitor(ResourceErrorMonitor, config, client.report.bind(client)), 2), reportResourceError = _a[0], tearDown = _a[1];
        client.on('beforeDestroy', tearDown);
        client.provide('reportResourceError', reportResourceError);
    });
}
//# sourceMappingURL=resource-error.js.map